import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Category } from '@/types';

interface SearchResultsDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  searchResults: { category: Category; rulePath: string[] }[];
}

export function SearchResultsDialog({ isOpen, setIsOpen, searchResults }: SearchResultsDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Search Results</DialogTitle>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto">
          {searchResults.length > 0 ? (
            <div className="space-y-2">
              {searchResults.map((result, index) => (
                <div key={index} className="p-2 border rounded">
                  <div className="font-medium">{result.category.name}</div>
                  <div className="text-sm text-gray-500">
                    Path: {result.rulePath.join(' > ')}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-gray-500 py-4">
              No matching categories found
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}